import '../styles/Contact.scss';
import ContactForm from './ContactForm';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import image from '../assets/lily-17.webp';

const panelVariant = (x) => ({
  hidden: { opacity: 0, x },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
});

function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact | Lily Lai Real Estate</title>
        <meta name="description" content="Get in touch with Lily Lai, Bay Area Realtor. Whether you're buying or selling in San Francisco, South San Francisco, Pacifica, or the Peninsula — reach out to get started." />
        <link rel="canonical" href="https://www.lilylaisf.com/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.lilylaisf.com/contact" />
        <meta property="og:title" content="Contact | Lily Lai Real Estate" />
        <meta property="og:description" content="Ready to make your move? Get in touch with Lily Lai, Bay Area Realtor." />
        <meta property="og:image" content="https://res.cloudinary.com/dlaituqwq/image/upload/f_auto,q_auto/rmbwaqpk3oqsvxjybjsc" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact | Lily Lai Real Estate" />
        <meta name="twitter:description" content="Ready to make your move? Get in touch with Lily Lai, Bay Area Realtor." />
        <meta name="twitter:image" content="https://res.cloudinary.com/dlaituqwq/image/upload/f_auto,q_auto/rmbwaqpk3oqsvxjybjsc" />
      </Helmet>

      <div className='contact-page'>
        <motion.div
          className='contact-photo-panel'
          variants={panelVariant(-48)}
          initial="hidden"
          animate="visible"
        >
          <img src={image} alt='Lily Lai' className='contact-photo' />
        </motion.div>
        <motion.div
          className='contact-form-panel'
          variants={panelVariant(48)}
          initial="hidden"
          animate="visible"
        >
          <div className='contact-form-inner'>
            <p className='contact-eyebrow'>Get In Touch</p>
            <h1 className='contact-heading'>Let's Connect</h1>
            <ContactForm />
          </div>
        </motion.div>
      </div>
    </>
  );
}

export default Contact;
